import React, { Component } from 'react';
import cifao from '../../images/cifão.png';
import axios from 'axios';
import Swal from 'sweetalert2';
import { transactionID } from "../../services/helpers";


class History extends Component {

    constructor() {
        super();
        let localStorageClientInfo = localStorage.getItem("clientInfo");

        this.state = {
            countMoth: 0,
            textVerMais: "Ver Mais",
            details: [],
            MSISDN: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).number : "",
            accessToken: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).accessToken : "",
        }
    };

    topUpHistory = () => {

        if (localStorage.getItem("clientInfo") === null) {
            return false;
        }

        var d = new Date();
        d.setMonth(d.getMonth() + 1);

        let _self = this;

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory`, {
            transactionID: transactionID("ABB"),
            MSISDN: this.state.MSISDN,
            "year": d.getFullYear(),
            "month": d.getMonth()
        }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
            .then(res => {
                if (res.data.code === "P00") {

                    if (res.data.details !== null) {

                        // let oderArray = res.data.details.sort(function(a,b) {
                        //     return (
                        //         isFinite(a.date=_self.convert(a.date).valueOf()) &&
                        //         isFinite(b.date=_self.convert(b.date).valueOf()) ?
                        //         (a.date>b.date)-(a.date<b.date) :
                        //         NaN
                        //     );
                        // });
                        // console.log("teste",oderArray);

                        this.setState({ details: [res.data.details.reverse()] });
                    }
                }
            })
            .catch(res => {
                console.log(res);
                Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao conectar com o servidor",
                    type: 'error'
                });
                this.setState({ redirect: true });
            })
    }

    getMoreHistory = (e) => {
        e.preventDefault();
        if (localStorage.getItem("clientInfo") === null) {
            return false;
        }

        this.setState({ textVerMais: "Carregando..." });

        var d = new Date();
        d.setMonth(d.getMonth() + this.state.countMoth);
        this.setState({
            countMoth: --this.state.countMoth
        })


        axios.post(`https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory`, {
            transactionID: transactionID("ABC"),
            MSISDN: this.state.MSISDN,
            "year": d.getMonth() !== 0 ? d.getFullYear() : d.getFullYear() - 1,
            "month": d.getMonth() !== 0 ? d.getMonth() : 12
        }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
            .then(res => {
                
                if (res.data.code === "P00") {

                    if (res.data.details !== null) {
                        let newDetails = [res.data.details.reverse(), this.state.details[0]];
                        // newDetails.push(res.data.details);
                        // console.log(newDetails);

                        this.setState({ details: newDetails });
                    }
                    else {
                        Swal.fire({
                            title: 'Erro!',
                            text: "Não mais registros para serem exibidos",
                            type: 'error'
                        });
                    }
                }
                else {
                    Swal.fire({
                        title: 'Erro!',
                        text: res.data.msg,
                        type: 'error'
                    });
                }
                this.setState({ textVerMais: "Ver Mais" });

            })
            .catch(res => {
                console.log(res);
                Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao conectar com o servidor",
                    type: 'error'
                });
                this.setState({ redirect: true, textVerMais: "Ver Mais" });
            })
    }

    componentDidMount = () => {
        this.topUpHistory()
    }


    render() {

        let { details } = this.state;
        console.log(details);
        return (
            <div className="content-history">
                <div className="content-history-top">
                    <h4>Histórico</h4>
                    {details.length !== 0 && <a href="#" onClick={this.getMoreHistory}>{this.state.textVerMais}</a>}
                </div>
                <div className="content-history-list">
                    <ul>
                        {details.map((item_, i_) =>
                            item_.map((item__, i__) =>
                                <li key={i__}>
                                    <div className="content-history-list-icon">
                                        <img src={cifao} alt="icon" />
                                    </div>
                                    <div className={`content-history-info ${item__.rechargeStatus}`}>
                                        <div className="content-history-list-top">
                                            <span>{(function () { var time = item__.date.split(" ")[1]; time.split(":"); return time.split(":")[0] + ":" + time.split(":")[1]; })()}</span>
                                            <span>{item__.date.split(" ")[0]}</span>
                                        </div>
                                        <p className="content-history-list-hash">#{item__.rechargeStatus}</p>
                                        <p className="content-history-list-text">Recarga no valor de R$ {item__.rechargeValue} 🤟</p>
                                    </div>
                                </li>
                            )
                        )}
                    </ul>
                </div>
            </div>

        )
    }


}

export default History; // Don’t forget to use export default!